import { Constants } from '../_constants/shared.constants';
const initialState = {};
function containerTripData(state = initialState, action) {
  switch (action.type) {
    case Constants.containerTripData.CONTAINER_DATA_SUCCESS:
      return {
        data: action.data,
      };
    default:
      return state
  }
}
export default containerTripData;